__turbopack_export_value__({
  "body-logo-18": "TestimonialsPage-module-scss-module__A3yC-a__body-logo-18",
  "body-text-12": "TestimonialsPage-module-scss-module__A3yC-a__body-text-12",
  "body-text-14": "TestimonialsPage-module-scss-module__A3yC-a__body-text-14",
  "body-text-16": "TestimonialsPage-module-scss-module__A3yC-a__body-text-16",
  "body-text-18": "TestimonialsPage-module-scss-module__A3yC-a__body-text-18",
  "body-text-20": "TestimonialsPage-module-scss-module__A3yC-a__body-text-20",
  "body-text-24": "TestimonialsPage-module-scss-module__A3yC-a__body-text-24",
  "body-text-24-2": "TestimonialsPage-module-scss-module__A3yC-a__body-text-24-2",
  "body-text-heading-2": "TestimonialsPage-module-scss-module__A3yC-a__body-text-heading-2",
  "body-text-heading-3": "TestimonialsPage-module-scss-module__A3yC-a__body-text-heading-3",
  "body-text-medium-14": "TestimonialsPage-module-scss-module__A3yC-a__body-text-medium-14",
  "body-text-medium-16": "TestimonialsPage-module-scss-module__A3yC-a__body-text-medium-16",
  "body-text-medium-18": "TestimonialsPage-module-scss-module__A3yC-a__body-text-medium-18",
  "body-text-medium2-18": "TestimonialsPage-module-scss-module__A3yC-a__body-text-medium2-18",
  "body-text2-14": "TestimonialsPage-module-scss-module__A3yC-a__body-text2-14",
  "body-text2-16": "TestimonialsPage-module-scss-module__A3yC-a__body-text2-16",
  "button-primary-text": "TestimonialsPage-module-scss-module__A3yC-a__button-primary-text",
  "button-text": "TestimonialsPage-module-scss-module__A3yC-a__button-text",
  "button2-text": "TestimonialsPage-module-scss-module__A3yC-a__button2-text",
  "card-shadow": "TestimonialsPage-module-scss-module__A3yC-a__card-shadow",
  "effect-menu": "TestimonialsPage-module-scss-module__A3yC-a__effect-menu",
  "header-1": "TestimonialsPage-module-scss-module__A3yC-a__header-1",
  "main-container": "TestimonialsPage-module-scss-module__A3yC-a__main-container",
  "main-footer-container": "TestimonialsPage-module-scss-module__A3yC-a__main-footer-container",
  "main-header-container": "TestimonialsPage-module-scss-module__A3yC-a__main-header-container",
  "testimonials": "TestimonialsPage-module-scss-module__A3yC-a__testimonials",
  "testimonials__button": "TestimonialsPage-module-scss-module__A3yC-a__testimonials__button",
  "testimonials__list": "TestimonialsPage-module-scss-module__A3yC-a__testimonials__list",
  "testimonials__navs": "TestimonialsPage-module-scss-module__A3yC-a__testimonials__navs",
  "testimonials__search": "TestimonialsPage-module-scss-module__A3yC-a__testimonials__search",
  "testimonials__tabsWrapper": "TestimonialsPage-module-scss-module__A3yC-a__testimonials__tabsWrapper",
  "txt-12-bold": "TestimonialsPage-module-scss-module__A3yC-a__txt-12-bold",
  "txt-14-bold": "TestimonialsPage-module-scss-module__A3yC-a__txt-14-bold",
  "txt-14-bold-caps": "TestimonialsPage-module-scss-module__A3yC-a__txt-14-bold-caps",
  "txt-14-med": "TestimonialsPage-module-scss-module__A3yC-a__txt-14-med",
  "txt-16-bold": "TestimonialsPage-module-scss-module__A3yC-a__txt-16-bold",
  "txt-16-med": "TestimonialsPage-module-scss-module__A3yC-a__txt-16-med",
  "txt-18-bold": "TestimonialsPage-module-scss-module__A3yC-a__txt-18-bold",
  "txt-18-medium": "TestimonialsPage-module-scss-module__A3yC-a__txt-18-medium",
  "txt-18-medium-24": "TestimonialsPage-module-scss-module__A3yC-a__txt-18-medium-24",
  "txt-24-semi": "TestimonialsPage-module-scss-module__A3yC-a__txt-24-semi",
});
